module.exports = "data:image/png;base64,bW9kdWxlLmV4cG9ydHMgPSAiYXNzZXRzL3Rpc2ljb3ZrYS1mYi5wbmciOw=="


//////////////////
// WEBPACK FOOTER
// ./src/images/tisicovka-fb.png
// module id = 215
// module chunks = 0